import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const fetchWorkerJobs = createAsyncThunk(
  "workerJobs/fetch",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BACKEND_URL}/allJobsApi`, {
        params: {
          role_type: filters.role_type || "",      // teacher | support
          category: filters.category || "",
          state: filters.state || "",
          city: filters.city || "",               // NEW
          job_type: filters.job_type || "",
          salary_min: filters.salary_min || "",
          salary_max: filters.salary_max || "",
        },
      });

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const workerJobsSlice = createSlice({
    name: 'workerJobs',
    initialState: {
    loading: false,
    error: null,
    jobs: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkerJobs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkerJobs.fulfilled, (state, action) => {
        state.loading = false;
        state.jobs = action.payload.data;
      })
      .addCase(fetchWorkerJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch worker jobs';
      })
  },
    });

export default workerJobsSlice.reducer;